import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { MAX_LOAN_AMOUNT } from './constants';

export const currencyMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 10,
});

export const loanAmountMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 7,
});

export const cryptoAmountMask = (decimalPlaces = 8) => [
  /\d/,
  '.',
  ...Array.from({ length: decimalPlaces }, () => /\d/),
];

export const unmask = (val) => val.replace(/[$, ]+/g, '');

export const numberUnmask = (val) => val.match(/\d+/g).join('');

export const routingNumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const accountMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  integerLimit: 17,
  allowLeadingZeroes: true,
});

export const floatUnmask = (val) => {
  const matches = val.match(/[\d.]+/g) || [];
  return matches.join('');
};

export const removeSpace = (str) => str.replace(/\s+/g, '');

export const removeUnderline = (str) => str.replace(/_+/g, '');

export const ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];

export const last4SsnMask = [/\d/, /\d/, /\d/, /\d/];
